<template>
  <div>
    <vxe-table
        class="table-style"
        stripe
        align="center"
        highlight-hover-row
        border="inner"
        :loading="loading"
        :data="rec"
        height="550"
    >
      <!-- <vxe-table-column field="userName" title="客户名称" show-overflow></vxe-table-column> -->
      <vxe-table-column field="realName" title="姓名" show-overflow></vxe-table-column>
      <vxe-table-column field="idcardNum" title="身份证号" show-overflow></vxe-table-column>
      <vxe-table-column field="regisiterNum" title="注册手机号" show-overflow></vxe-table-column>
      <vxe-table-column field="carrier" title="运营商" show-overflow></vxe-table-column>
      <vxe-table-column field="yidunReasonType" title="异常原因" show-overflow>
        <template #header>
          <div style="display: flex;align-items: center;">
            <span>出错原因</span>
            <!-- <Poptip trigger="hover" placement="top" transfer>
              <i class="vxe-icon--question" style="margin-left: 5px;cursor: pointer;"></i>
              <template slot="content">
                <div>
                              <span>1. 空号即为近一个月内出现过空号的号码<br>
                                2. 停机即为近一个月内出现过停机的号码（命中准确率100%，误差率5%)。出现误差的原因：可能停机的手机号恢复使用<br>
                                3. 查询无记录是指利用API接口检测中，系统无法在数据库中查询到该号码<br>
                                4. 沉默号里面分为两种状态，一种是超过半年没有激活过的空号，二是近三月流量均消耗低于30M，且近三个月平均流量低于<br>
                                30M的用户也有可能随时停机，简单的来说就是快投入市场的空号、小号、新号、非智能机客户，我们认为这种是对移动互联网<br>
                                没有太大的兴趣人群<br>
                                5. 风险号属于长时间关机或未开通语音服务以及易投诉的用户<br></span>
                </div>
              </template>
            </Poptip> -->
          </div>
        </template>
        <template slot-scope="{ row }">
          <span>{{ yidunReasonType(row) }}</span>
        </template>
      </vxe-table-column>
    </vxe-table>
  </div>
</template>
<script>
  import $api from '@/apiProvider';

  export default {
    data() {
      return {
        rec: [],
        loading: false
      }
    },
    methods: {
      yidunReasonType(row) {
        if (row.yidunCheckType === 1) {
          if (row.yidunStatus === 500) {
            return row.yidunError;
          } else {
            let val = row.yidunReasonType;
            if (val != null) {
              if (val === 2) {
                return "认证不一致";
              }
              if (val === 3) {
                return "该手机号查询无记录";
              }
              if (val === 4) {
                return "认证信息有误";
              }
              if (val === 5) {
                return "号码状态异常（空号、停机等）";
              }
              if (val === 6) {
                return "解析手机号运营商失败";
              }
              if (val === 7) {
                return "其他出错，请联系客服";
              }
            } else {
              return "未知";
            }
          }
        } else {
          if (row.yidunStatus === 2) {
            return "校验失败";
          }
          let val = row.yidunReasonType;
          if (val != null) {
            if (val === 0) {
              return "空号";
            }
            if (val === 2) {
              return "停机";
            }
            // if (val === 3) {
            //   return "库无";
            // }
            // if (val === 4) {
            //   return "沉默号";
            // }
            // if (val === 5) {
            //   return "风险号";
            // }
            if (val === 6) {
              return "关机";
            }
            if (val === 7) {
              return "疑似关机";
            }
            if (val === 8) {
              return "忙";
            }
          } else {
            return "未知";
          }
        }
      },
      init(row) {
        this.queryUserErrorDetailList(row);
      },
      async queryUserErrorDetailList(row) {
        let res = await $api.gcdUser.get("queryUserErrorDetailList", row);
        if (res.status === 1) {
          this.rec = res.data;
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : "接口异常",
            status: "error",
          });
        }
      }
    }
  }
</script>
<style>

</style>